
import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

const DriverTrainingHeader: React.FC = () => {
  const { t } = useTranslation('training');

  return (
    <>
      <div className="flex justify-between mb-4">
        <div className="text-golf-600">
          <Link to="/training" className="text-green-600 hover:text-green-700 flex items-center gap-2">
            <ChevronLeft className="h-5 w-5" />
            <span>{t('driver.backToTraining')}</span>
          </Link>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-8"
      >
        <h1 className="text-4xl font-bold text-golf-800 mb-4">{t('driver.title')}</h1>
        <p className="text-xl text-golf-600 mb-2">{t('driver.subtitle')}</p>
      </motion.div>

    </>
  );
};

export default DriverTrainingHeader;
